var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guests",
    clipPath: "url(#clip0_1422_385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.7617 68.5232L51.5803 73.5139L72.9849 69.4255L92.2314 78.3511L85.878 44.9929L77.064 39.8115",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M63.2713 39.6815C63.2713 39.6815 56.4945 42.4349 54.0666 43.3838C49.1317 41.1745 35.9782 35.6582 35.9782 35.6582L21.4108 39.728L1.44336 69.3791L10.4387 67.2396",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.9781 35.6533L32.6758 50.751",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.3328 53.8857L51.584 73.5137",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M69.0725 46.6303C69.0725 46.6303 56.3237 34.2117 57.1283 22.7419C57.933 11.2722 67.3888 10.8908 71.5609 11.1791C75.733 11.4722 85.0074 13.6908 84.2028 25.1605C83.3981 36.6303 69.0772 46.6257 69.0772 46.6257L69.0725 46.6303Z",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M71.5322 19.0393C70.4903 18.9648 65.6857 20.2021 65.3927 24.3741C65.0996 28.5462 68.1554 29.8067 70.2392 29.9509C72.3229 30.0951 75.5973 28.23 75.8903 24.0579C76.1833 19.8858 73.0903 19.1462 71.5275 19.0393H71.5322Z",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M46.002 86.0908C45.1788 83.8583 37.5369 76.3466 37.5369 76.3466C40.1369 73.728 41.7044 70.2583 41.9602 66.5792C42.5555 58.0722 36.3695 50.2908 27.6392 50.1001C18.909 49.9094 11.7509 55.9141 11.1555 64.421C10.5602 72.928 16.9695 80.3048 25.4765 80.9001C28.5183 81.1141 32.3369 79.2676 33.909 79.0722C36.8392 82.1978 41.4206 88.5141 42.5881 89.0583C43.7555 89.6024 45.0206 89.7885 45.7788 89.2815C46.5369 88.7745 47.0951 87.7234 46.0067 86.0908H46.002Z",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M35.7137 66.1046C35.3555 71.2163 31.4392 74.2953 25.8113 74.7093C20.6997 75.0814 16.8485 69.914 17.2067 64.807C17.5648 59.7 22.0904 55.1837 27.109 56.2023C33.4392 57.4814 36.0718 60.993 35.7137 66.1046Z",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M8.41127 80.9561L2.35547 82.784",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.5474 88.0068L14.9102 95.3743",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.0127 86.1514L7.54297 91.4397",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M93.043 21.2344L99.0988 23.053",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M90.1562 10.8622L95.5842 5.625",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M93.7422 15.4676L99.5561 12.9746",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1422_385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuest);
export default __webpack_public_path__ + "static/media/guest.3d02ef695ffc56e5f916d9a5f9a112fc.svg";
export { ForwardRef as ReactComponent };